module.exports = __webpack_public_path__ + "static/img/A131.ad3e78b5.jpg";